import plausible from 'plausible-tracker'

import { webAppState } from '@/appState'
import { normalizePlausiblePathname } from '@/utils/plausible/normalizePlausiblePathname'

const plausibleInstance = plausible({
    domain: 'app.campai.com',
})

export const trackPageViews = (pathname: string) => {
    if (webAppState.isDevelopment || !webAppState.tenant || webAppState.isLocalhost) {
        return
    }

    const path = normalizePlausiblePathname(pathname, webAppState.tenant!.name)
    const url = `${window.location.origin}/${path}`
    plausibleInstance.trackPageview({ url })
}
